module.exports = __webpack_public_path__ + "img/leads-icon-6.ca4e7158.jpg";